import { render, staticRenderFns } from "./wheelPage.vue?vue&type=template&id=59e8a56b&"
import script from "./wheelPage.vue?vue&type=script&lang=js&"
export * from "./wheelPage.vue?vue&type=script&lang=js&"
import style0 from "./wheelPage.vue?vue&type=style&index=0&id=59e8a56b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports